import React from 'react';

export const SuccessIllustration = () => (
  <svg
    className="dialog-success-svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle className="dialog-success-circle" cx="24" cy="24" r="24" fill="#22C55E" />
    <path
      className="dialog-success-check"
      d="M16 24 L21 29 L32 18"
      stroke="white"
      strokeWidth="2.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WarningIllustration = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M24 4 L44 40 L4 40 Z" fill="#FF9800"/>
    <path d="M24 16 L24 26" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
    <circle cx="24" cy="32" r="1.5" fill="white"/>
  </svg>
);

export const NoticeIllustration = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24" cy="24" r="24" fill="#1BA973" />
    <path d="M24 14 L24 28" stroke="white" strokeWidth="2.8" strokeLinecap="round" />
    <circle cx="24" cy="34" r="2" fill="white" />
  </svg>
);

export const ErrorIllustration = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24" cy="24" r="24" fill="#F44336"/>
    <path d="M18 18 L30 30 M30 18 L18 30" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
  </svg>
);

export const QuestionIllustration = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24" cy="24" r="24" fill="#432568"/>
    <path d="M20 20 Q24 16 28 20 Q30 24 24 28" stroke="white" strokeWidth="2.5" strokeLinecap="round" fill="none"/>
    <circle cx="24" cy="34" r="1.5" fill="white"/>
  </svg>
);

export const DangerConfirmIllustration = () => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="28" cy="28" r="28" fill="#FDECEE" />
    <path
      d="M28 14L41 38.5H15L28 14Z"
      fill="#FF4D6D"
    />
    <path
      d="M28 23V30"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <circle cx="28" cy="34" r="1.8" fill="white" />
  </svg>
);
